import { useState, useEffect } from "react";

/**
 * useCanSharePdf
 * Checks if the browser supports sharing PDF files via the Web Share API (Level 2)
 *
 * @returns {boolean} canSharePdf - true if PDF sharing is supported
 */
export function useCanSharePdf() {
    const [canSharePdf, setCanSharePdf] = useState(false);

    useEffect(() => {
        const checkPdfSupport = () => {
            try {
                if (typeof navigator.canShare !== "function") return false;
                const blob = new Blob(["x"], { type: "application/pdf" });
                const file = new File([blob], "test.pdf", { type: "application/pdf" });
                return navigator.canShare({ files: [file] });
            } 
            catch {
                return false;
            }
        };

        setCanSharePdf(checkPdfSupport());
    }, []);

    return canSharePdf;
}
